import React from 'react';
import { COLORS, TYPE, WEIGHT, LETTER } from '../../styles/tokens';

export interface SectionHeadingProps {
  /** Optional small uppercase eyebrow above the title. */
  eyebrow?: string;
  /** Bold heading text. Use <br/> via `secondLine` for an opacity-72% second line. */
  title: string;
  /** Second line rendered at 72% opacity below the main title, on its own line. */
  secondLine?: string;
  /** Body paragraph below the heading. */
  subtitle?: string;
  /** Override max-width of the subtitle paragraph. */
  subtitleMaxWidth?: number;
}

// Standard section heading used by ProblemSection, HowItWorks, WhyBetter,
// Trust, ReportPreviewBlock, PlanFormSection, FinalCTASection. Centred,
// canonical font scale, optional eyebrow + softened second line + subtitle.
export default function SectionHeading({
  eyebrow,
  title,
  secondLine,
  subtitle,
  subtitleMaxWidth = 540,
}: SectionHeadingProps) {
  return (
    <div style={{ textAlign: 'center' }}>
      {eyebrow && (
        <p style={{
          fontSize: TYPE.eyebrow,
          fontWeight: WEIGHT.semibold,
          letterSpacing: LETTER.uppercase,
          textTransform: 'uppercase',
          color: COLORS.textMuted,
          marginBottom: 14,
        }}>
          {eyebrow}
        </p>
      )}
      <h2 style={{
        fontSize: TYPE.sectionH2,
        fontWeight: WEIGHT.bold,
        lineHeight: 1.15,
        letterSpacing: LETTER.tightTitle,
        color: 'white',
        marginBottom: subtitle ? 14 : 0,
      }}>
        {title}
        {secondLine && (
          <>
            <br />
            <span style={{ opacity: 0.72 }}>{secondLine}</span>
          </>
        )}
      </h2>
      {subtitle && (
        <p style={{
          fontSize: TYPE.sectionSub,
          color: COLORS.textBody,
          lineHeight: 1.65,
          maxWidth: subtitleMaxWidth,
          margin: '0 auto',
        }}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
